/**
 * Newsletter Popup mit Exit Intent, Zeitverzögerung oder Scroll Trigger
 * Für Van den Berg Shopify Theme
 */

(function () {
    'use strict';

    // Konfiguration aus Shopify Settings
    const config = {
        enabled: window.newsletterPopupConfig?.enabled || false,
        trigger: window.newsletterPopupConfig?.trigger || 'exit_intent',
        delay: (window.newsletterPopupConfig?.delay || 5) * 1000,
        scrollPercent: window.newsletterPopupConfig?.scrollPercent || 50,
        frequency: window.newsletterPopupConfig?.frequency || 7
    };

    // Cookie-Namen
    const COOKIE_NAME = 'newsletter_popup_shown';
    const SUBSCRIBED_COOKIE = 'newsletter_popup_subscribed';

    // State
    let popupShown = false;
    let exitIntentTriggered = false;

    /**
     * Cookie-Hilfsfunktionen
     */
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }

    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    }

    /**
     * Prüft ob das Popup angezeigt werden soll
     */
    function shouldShowPopup() {
        // Nicht anzeigen wenn bereits abonniert
        if (getCookie(SUBSCRIBED_COOKIE)) {
            return false;
        }

        // Nicht anzeigen wenn kürzlich geschlossen
        if (getCookie(COOKIE_NAME)) {
            return false;
        }

        // Nicht auf Checkout/Challenge Seiten anzeigen
        if (window.location.pathname.includes('/checkout') ||
            window.location.pathname.includes('/challenge')) {
            return false;
        }

        return config.enabled;
    }

    /**
     * Zeigt das Popup an
     */
    function showPopup() {
        if (popupShown || !shouldShowPopup()) return;

        const overlay = document.getElementById('newsletter-popup-overlay');
        if (!overlay) return;

        popupShown = true;
        overlay.style.display = 'flex';

        // Focus auf Email-Input setzen
        setTimeout(() => {
            const emailInput = document.getElementById('newsletter-popup-email');
            if (emailInput) {
                emailInput.focus();
            }
        }, 100);

        // ESC-Taste zum Schließen
        document.addEventListener('keydown', handleEscKey);
    }

    /**
     * Schließt das Popup
     */
    window.closeNewsletterPopup = function () {
        const overlay = document.getElementById('newsletter-popup-overlay');
        if (overlay) {
            overlay.style.display = 'none';
        }

        // Cookie setzen damit Popup nicht sofort wieder erscheint
        setCookie(COOKIE_NAME, 'true', config.frequency);

        document.removeEventListener('keydown', handleEscKey);
    };

    /**
     * ESC-Taste Handler
     */
    function handleEscKey(e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            window.closeNewsletterPopup();
        }
    }

    /**
     * Exit Intent Handler (Maus verlässt Fenster oben)
     */
    function handleMouseLeave(e) {
        if (exitIntentTriggered) return;

        // Nur triggern wenn Maus oben aus dem Fenster geht
        if (e.clientY <= 0) {
            exitIntentTriggered = true;
            showPopup();
        }
    }

    /**
     * Scroll Handler
     */
    function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrollPercent = (scrollTop / docHeight) * 100;

        if (scrollPercent >= config.scrollPercent) {
            showPopup();
            window.removeEventListener('scroll', handleScroll);
        }
    }

    /**
     * Klick außerhalb des Popups zum Schließen
     */
    function handleOverlayClick(e) {
        if (e.target.id === 'newsletter-popup-overlay') {
            window.closeNewsletterPopup();
        }
    }

    /**
     * Initialisierung
     */
    function init() {
        if (!shouldShowPopup()) return;

        const overlay = document.getElementById('newsletter-popup-overlay');
        if (!overlay) return;

        // Klick außerhalb schließt Popup
        overlay.addEventListener('click', handleOverlayClick);

        // Trigger basierend auf Konfiguration
        switch (config.trigger) {
            case 'exit_intent':
                document.addEventListener('mouseleave', handleMouseLeave);

                // Fallback für Touch-Geräte: Nach 10 Sekunden anzeigen
                if ('ontouchstart' in window) {
                    setTimeout(showPopup, 10000);
                }
                break;

            case 'delay':
                setTimeout(showPopup, config.delay);
                break;

            case 'scroll':
                window.addEventListener('scroll', handleScroll);
                break;
        }
    }

    // Warten auf DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
